import React from 'react';

import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import type { SxProps, Theme } from '@mui/material/styles';

type Props = {
  label: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  sx?: SxProps<Theme>;
};

const StepCheckbox = ({ label, checked, onChange, sx }: Props) => {
  return (
    <FormControlLabel
      control={<Checkbox checked={checked} onChange={onChange} sx={sx} />}
      label={label}
    />
  );
};

export default StepCheckbox;
